import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import {
  atomNodeIdSelected,
  atomSidePanelIsOpen,
} from '@/src/modules/AutomationModuleNew/atoms/flows';

export const useHandleSidePanel = () => {
  const setSidePanelIsOpen = useSetAtom(atomSidePanelIsOpen);
  const setNodeIdSelected = useSetAtom(atomNodeIdSelected);

  const handleOpenSidePanel = useCallback(
    (nodeId: string | number) => {
      setNodeIdSelected(nodeId);
      setSidePanelIsOpen(true);
    },
    [setNodeIdSelected, setSidePanelIsOpen]
  );

  const handleCloseSidePanel = useCallback(() => {
    setSidePanelIsOpen(false);
  }, [setSidePanelIsOpen]);

  return { handleOpenSidePanel, handleCloseSidePanel };
};
